import React from 'react';

const Box = props => {
  const alignment = props.alignment || 'center';
  return <div className={'alert ' + props.className} role="alert">
    <div className={'row justify-content-' + alignment}>
      <div className={'col-auto' + (alignment === 'center' ? ' text-center' : '')}>
        {props.children}
      </div>
    </div>
  </div>;
}
export default Box;
